import React, { FC } from 'react';
import { IWizardProps } from 'types/wizard';
import ChecklistPage from '../Pages/Customize/ChecklistPage';

const Customize: FC<IWizardProps> = (props) => <ChecklistPage {...props} />;

export default Customize;
